(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["verified-product-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('irazmo-review-carousel')){
  customElements.define('irazmo-review-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      const track=this.querySelector('.irazmo-review-track');
      const buttons=this.querySelectorAll('[data-direction]');
this.querySelectorAll('.irazmo-review-read-more').forEach(button=>button.addEventListener('click',()=>{
const expanded=button.getAttribute('aria-expanded')!=='true';
button.setAttribute('aria-expanded',String(expanded));
button.closest('.irazmo-review-card').classList.toggle('is-expanded',expanded);
button.textContent=expanded?button.dataset.less:button.dataset.more;
}));
      const update=()=>{
this.querySelectorAll('.irazmo-review-card').forEach(card=>{
const button=card.querySelector('.irazmo-review-read-more');
if(!button)return;
const expanded=card.classList.contains('is-expanded');
const clipped=Array.from(card.querySelectorAll('h3,.irazmo-review-body')).some(text=>text.scrollHeight>text.clientHeight+1);
button.hidden=!expanded&&!clipped;
});
const max=track.scrollWidth-track.clientWidth;buttons.forEach(button=>{button.disabled=Number(button.dataset.direction)<0?track.scrollLeft<2:track.scrollLeft>=max-2;});};
      buttons.forEach(button=>button.addEventListener('click',()=>{const card=track.querySelector('.irazmo-review-card');if(!card)return;const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:(card.getBoundingClientRect().width+gap)*Number(button.dataset.direction),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));
      track.addEventListener('scroll',update,{passive:true});
      this.observer=new ResizeObserver(update);this.observer.observe(track);update();
    }
    disconnectedCallback(){this.observer?.disconnect();this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
